/* ==========================================================================
   LUX — Scroll reveals
   One shared IntersectionObserver for the whole page. Elements are unobserved
   as soon as they have played, and will-change is dropped once the transition
   ends, so nothing keeps a compositor layer alive for the life of the page.
   ========================================================================== */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  function settle(el) {
    var done = function () {
      el.classList.add('is-settled');
      el.removeEventListener('transitionend', done);
    };
    el.addEventListener('transitionend', done);
    // Fallback in case the transition never fires (element hidden, etc).
    window.setTimeout(done, 1400);
  }

  function reveal(el) {
    el.classList.add('is-visible');
    settle(el);
  }

  function getObserver() {
    if (observer) return observer;

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      // Fire a little before the element reaches the viewport so the motion
      // has finished by the time it is properly in view.
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.01
    });

    return observer;
  }

  function prepare(el) {
    if (el.dataset.luxRevealBound === 'true') return;
    el.dataset.luxRevealBound = 'true';

    // Anything already on screen at load reveals immediately — no flash of
    // invisible content above the fold.
    var rect = el.getBoundingClientRect();
    var threshold = parseInt(el.getAttribute('data-reveal-threshold'), 10);

    if (!isNaN(threshold) && threshold === 0) {
      reveal(el);
      return;
    }

    if (rect.top < window.innerHeight * 0.9 && rect.bottom > 0) {
      reveal(el);
      return;
    }

    getObserver().observe(el);
  }

  function init(scope) {
    var els = (scope || document).querySelectorAll('[data-lux-reveal]');
    if (!els.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) {
        el.classList.add('is-visible', 'is-settled');
      });
      return;
    }

    Array.prototype.forEach.call(els, prepare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* ---------------------------------------------------------------------
     Marquee: duplicate the track once so the -50% keyframe loops seamlessly.
     --------------------------------------------------------------------- */

  function initMarquee(scope) {
    var tracks = (scope || document).querySelectorAll('[data-lux-marquee]');

    Array.prototype.forEach.call(tracks, function (track) {
      if (track.dataset.luxCloned === 'true') return;
      track.dataset.luxCloned = 'true';

      var original = track.innerHTML;
      track.innerHTML = original + original;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initMarquee(document); });
  } else {
    initMarquee(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initMarquee(e.target); });
})();
